import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import { IoCloseOutline } from "react-icons/io5";

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
`;

const DimBackground = styled.div`
  position: fixed;
  inset: 0;
  /* background-color: rgba(0, 0, 0, 0.1); */
  z-index: 1000;
`;

const TopBar = styled.div`
  position: fixed;
  top: 140px;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: white;
  display: flex;
  align-items: center;
  padding: 0 20px;
  z-index: 1001;
  border: 1px solid ${colors.line};
  box-sizing: border-box;
`;

const Input = styled.input`
  flex: 1;
  height: 36px;
  padding: 0 12px;
  font-size: ${fontSize.m};
  border: none;
  outline: none;
  caret-color: ${colors.black};
  &::placeholder {
    color: ${colors.primaryGray};
  }
`;

const CloseIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;

  margin-left: 12px;

  color: black;
  font-size: 28px;
  cursor: pointer;
  flex-shrink: 0; 
`;

function SearchOverlay({ onClose }) {
  return ReactDOM.createPortal(
    <Wrapper>
      <DimBackground onClick={onClose} />

      <TopBar onClick={(e) => e.stopPropagation()}>
        <Input type="text" placeholder="Search..." autoFocus />
        <CloseIcon onClick={onClose}>
          <IoCloseOutline />
        </CloseIcon>
      </TopBar>
    </Wrapper>,
    document.body
  );
}

export default SearchOverlay;
